import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import ivclass from '../../Modules/IVClass';
import { AssetsAppName, CrossIcon, getWebAssetsUrl, SearchDarkIcon, SearchWhiteIcon, } from '../../utils/web-assets';
import styles from './TemplateSearch.module.scss';
import { debounceWrapper } from '../../utils/common';
import { Analytics } from '../../utils/analytics';
import { AnalyticsType } from '../../types/Analytics';
import { EVENTS } from '../../constants/events';
const TemplateSearch = ({ searchQuery, scrollToTop, autoComplete, searchTemplates, analyticsSource = '', }) => {
    const searchIconUrl = getWebAssetsUrl(SearchDarkIcon, AssetsAppName.LIHP);
    const crossIconUrl = getWebAssetsUrl(CrossIcon, AssetsAppName.LIHP);
    const searchWhiteIconUrl = getWebAssetsUrl(SearchWhiteIcon, AssetsAppName.LIHP);
    const [query, setQuery] = useState('');
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const suggestionRef = useRef(null);
    const autoCompleteDebounced = debounceWrapper(async (searchTem) => {
        if (searchTem.length > 2) {
            const suggestions = await autoComplete(searchTem);
            setSearchSuggestions(suggestions);
        }
        else {
            setSearchSuggestions([]);
        }
    }, 600);
    const onSearch = (queryString) => {
        if (searchQuery !== queryString) {
            searchTemplates(queryString);
            scrollToTop();
            Analytics.withEventProperties({
                Source: analyticsSource || '',
                Keyword: queryString,
                'Started with keyword': queryString,
                'Started with route': 'Search',
            })
                .withUserProperties({
                'Started with keyword': queryString,
                'Started with route': 'Search',
            })
                .send(AnalyticsType.AMPLITUDE, {
                eventName: EVENTS.SEARCH_TEMPLATE,
            });
        }
    };
    const handleKeydown = (e) => {
        if (e.key === 'Enter') {
            onSearch(query);
        }
        else if (e.key === 'Escape') {
            setQuery('');
        }
    };
    const handleInput = (e) => {
        setQuery(e.currentTarget.value);
        autoCompleteDebounced(e.currentTarget.value);
    };
    const handleOnBlur = (e) => {
        if (!e.currentTarget.value) {
            setQuery('');
            onSearch('');
        }
    };
    useEffect(() => {
        if (searchQuery !== query) {
            setQuery(searchQuery);
        }
    }, [searchQuery]);
    useEffect(() => {
        const eventHandler = (event) => {
            if (event.target &&
                !suggestionRef.current?.contains(event.target))
                setSearchSuggestions([]);
        };
        if (searchSuggestions.length > 0) {
            document.addEventListener('click', eventHandler);
            return () => {
                document.removeEventListener('click', eventHandler);
            };
        }
    }, [searchSuggestions]);
    return (_jsxs("div", { className: "iv-relative", children: [_jsxs("div", { className: ivclass('iv-flex iv-items-center', 'iv-h-28', 'iv-bg-grey-5', 'iv-rounded-full', styles.outlinedSearchBox), children: [_jsx("img", { className: "iv-ml-[8px] iv-h-[16px] iv-w-[16px]", width: "16", height: "16", alt: "", src: searchIconUrl }), _jsx("input", { type: "text", className: ivclass('iv-flex-grow', 'iv-bg-grey-5', 'iv-pl-[8px]', 'iv-border-0', 'iv-text-grey-100', 'iv-text-body-m', 'iv-font-medium', 'iv-rounded-full', 'placeholder:iv-text-black-40', 'placeholder:iv-text-body-m', 'placeholder:iv-font-medium'), placeholder: `Try 'video ads'`, value: query, onInput: handleInput, onKeyDown: handleKeydown, onBlur: handleOnBlur }), query.length > 0 && (_jsx("button", { className: "iv-border-0 iv-p-0 iv-bg-grey-5 iv-rounded-full iv-flex iv-items-center", onClick: () => {
                            onSearch('');
                            setQuery('');
                        }, children: _jsx("img", { src: crossIconUrl, alt: "", className: ivclass('!iv-cursor-default', 'iv-w-[8px]', 'iv-mr-10') }) }))] }), searchSuggestions.length > 0 && (_jsxs("div", { className: ivclass('iv-absolute iv-top-[30px] iv-left-0 iv-right-0 iv-z-10', 'iv-bg-grey-85', 'iv-text-body-l iv-text-grey-0', 'iv-px-[12px] iv-py-[6px]', 'iv-rounded-sm'), children: [_jsx("div", { className: "iv-text-body-m iv-text-white-60", children: "Suggested keywords" }), _jsx("hr", { className: ivclass('iv-border-grey-80', 'iv-my-5 iv-mx-[-12px]') }), searchSuggestions.map(keyword => (_jsxs("div", { ref: suggestionRef, className: ivclass('iv-flex iv-items-center', 'iv-h-28', 'iv-my-[4px] iv-mx-[-12px] iv-py-[4px] iv-pl-[16px] iv-pr-[12px]', 'hover:iv-bg-light-blue', 'iv-cursor-default', styles.suggestedListItem), onClick: () => {
                            setQuery(keyword.value);
                            onSearch(keyword.value);
                        }, children: [_jsx("img", { className: ivclass('iv-mr-10'), width: "14", height: "14", src: searchWhiteIconUrl, alt: "" }), _jsx("span", { dangerouslySetInnerHTML: { __html: keyword.display_name } })] })))] }))] }));
};
export default TemplateSearch;
